
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/terms",
      function () {
        return require("private-next-pages/[locale]/terms.tsx");
      }
    ]);
  